import React from "react";
import { ChakraProvider, defaultSystem } from "@chakra-ui/react";

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return <ChakraProvider value={defaultSystem}>{element}</ChakraProvider>;
};